import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { apiGet, apiPost, hasPermission } from '../../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { NavLink } from 'react-router-dom';
import { popupActions } from '../../../store/popupStore';
import { Redirect } from 'react-router';
import { registrySearchActions, REGISTRY, SEARCH_TYPE } from '../../../store/ceeSearchStore';
import { Translate, withLocalize } from 'react-localize-redux';
import { writeErr } from '../../common/logger';
import BbCheckbox from '../../styling/bbCheckbox';
import BbInput from '../../styling/bbInput';
import CeeReportDateInformation from './ceeReportDateInformation';
import CeeSearchCriteria from './ceeSearchCriteria';
import classnames from 'classnames';
import ExcelExportButton from '../../common/excelExportButton';
import Message from '../../common/message';
import moment from "moment";
import Money from '../../common/moneyComponent';
import NoDataComponent from '../../common/noDataComponent';
import ResponsiveTable from "../../layoutItems/responsiveTable";
import Section from '../../common/section';
import SvgRefresh from "../../../img/icons/Refresh";
import RpveDetail from './rpveDetail';
import './cee.scss';

const OPTIONS = {
    all: "all",
    firstN: "firstN",
    choose: "choose"
};

const CAUSES_MIN = 1;
const CAUSES_MAX = 100;

class CeeDetail extends React.Component {
    state = {
        isLoading: true,
        data: [],
        country: this.props.match.url.indexOf(REGISTRY.cee) > 0 ? "CZ" : "SK",
        fragment: this.props.match.url.indexOf(REGISTRY.cee) > 0 ? REGISTRY.cee : this.props.match.url.indexOf(REGISTRY.cre) ? REGISTRY.cre : REGISTRY.rpve,
        searchType: null,
        ceeCheck: null,
        creCheck: null,
        checked: [],
        option: OPTIONS.firstN,
        howMany: undefined,
        refreshReqInit: false,
        responseData: null,
        isRpve: false
    }

    render() {
        if (this.state.refreshReqInit && this.props[this.state.fragment].requestResult === true)
            return <Redirect to={`/search/${this.state.fragment}/results`} />;

        if (this.state.isRpve)
            return <RpveDetail requestId={this.props.match.params.id} setResultsRequestParams={this.props.setResultsRequestParams} setRpveData={this.setRpveData} updateData={this.updateData} />

        if (this.state.isLoading)
            return <Circles />

        if (isNullOrUndefined(this.state.data))
            return <NoDataComponent />;

        return this.renderWithData();
    }

    componentDidMount() {
        this.update();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.url !== this.props.match.url) {
            this.update();
        }
    }

    update() {
        if (this.props.match.url.includes("rpve")) {
            if (this.state.isRpve) return;
            this.setState({ isRpve: true });
        } else {
            if (this.state.isRpve) this.setState({ isRpve: false });
        }

        if (!this.props.match.url.includes("rpve")) this.getData();
    }

    renderWithData() {
        return (
            <div className="cee-detail">
                {this.renderErrors()}
                {this.state.data && this.state.data.details && <>
                    <div style={{ paddingTop: "1em" }}></div>
                    {this.state.data.details.length > 0 &&
                        <Section isSection={true} removeDataLevel={true} bodyStyle={{ border: "none" }} style={{ border: "none" }}
                            headerStyle={{ marginLeft: "0", border: "none", cursor: "default" }} isOpen={true} fontAwesomeIconName="search-dollar"
                            name={this.props.translate("Search.Cee.OneTimePrice")}
                        >
                            <div className="cee-detail-price-section">
                                <div className="columns is-multiline">
                                    <div className="column is-narrow with-margin-right cee-detail-select">
                                        <div className="with-margin-right" style={{ width: '15em' }}>
                                            <Translate id="Search.Cee.OneTimePrice" />
                                        </div>
                                        <BbInput type='select-noformik' placeholder={{ type: 'inline' }}
                                            className='field' value={{ label: this.props.translate(this.getOptionLabel(this.state.option)), value: this.state.option }}
                                            options={[OPTIONS.all, OPTIONS.firstN, OPTIONS.choose].map(o => ({ label: this.props.translate(this.getOptionLabel(o)), value: o }))}
                                            onChange={e => this.onOptionChange(e.value)} />
                                    </div>
                                    <div className="column is-narrow with-margin-right" style={{ display: this.state.option !== OPTIONS.firstN ? "none" : "block" }}>
                                        <div className="control">
                                            <label className="with-margin-right">{ReactHtmlParser(this.props.translate('Search.Cee.Define.N'))}</label>
                                            <input
                                                id="defineNField"
                                                type="number"
                                                value={this.state.howMany}
                                                min={CAUSES_MIN}
                                                max={CAUSES_MAX}
                                                onChange={(event) => this.onHowManyChange(event.target.value)}
                                                className="input form-control"
                                                style={{ width: "4em" }}
                                            />
                                        </div>
                                    </div>
                                    <div className="column is-narrow">
                                        <button className={classnames('bb-button small gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                            disabled={(this.state.checked.length === 0 && this.state.option === OPTIONS.choose) ||
                                                (this.state.option === OPTIONS.firstN && this.state.checked.length === 0)}
                                            onClick={() => this.showPopup(true)}
                                        >
                                            Ok
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Section>
                    }
                    <div className='report-section' style={{ border: "none" }}>
                        <div className='header-wrap' style={{ marginLeft: "0", border: "none", cursor: "default" }}>
                            <div className="header-body" >
                                <div className="name">{this.props.translate("Search.Cee.SearchParameters")}</div>
                            </div>
                        </div>
                        <div className='report-section-body' style={{ border: "none", marginLeft: 0 }}>
                            <div>
                                <CeeSearchCriteria country={this.state.country} data={this.state.data} registry={this.state.fragment} />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                {<div className="aml-available">
                                    <div className="columns">
                                        <div className="column is-narrow" style={{ display: "flex", alignItems: "center" }}>
                                            <SvgRefresh className="refresh-icon" />
                                            <div style={{ justifyContent: "flex-start" }} className="link-internal" onClick={() => this.updateData(this.state.data, false)}>
                                                <Translate id={`Search.${this.state.fragment === REGISTRY.cee ? 'Cee' : 'Cre'}.UpdateData`} />
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                <CeeReportDateInformation inserted={this.state.data.header.insertedFormated}
                                    completed={this.state.data.header.completedFormated}
                                    obligation={this.state.data.details.length > 0 ? this.state.data.header.obligationAddedFormated : null}
                                />
                            </div>
                            <div className="search-results-manager" style={{ fontWeight: "bold", paddingBottom: "1em" }}>
                                <div className='result-counts'>
                                    <span>
                                        <Translate id="Search.Cee.ResultCount" />:&nbsp;&nbsp;
                                        {this.state.data.details.length}
                                    </span>
                                </div>
                            </div>
                            {this.state.data.details.length > 0 && <div>
                                <ResponsiveTable>
                                    <table className="table table-report-section-3">
                                        <thead>
                                            <tr>
                                                <th><Translate id="Search.Cee.Type" /></th>
                                                <th><Translate id="Search.Relations.Subject" /></th>
                                                <th><Translate id="Search.Cee.Cause.FileNo" /></th>
                                                {this.state.country == "CZ" && <th><span title={this.props.translate('Search.Cee.ExecutionInitiation.Description')}><Translate id="Search.Cee.ExecutionInitiation" /></span></th>}
                                                {this.state.country == "CZ" && <th><Translate id="Search.Cee.RegDate" /></th>}
                                                {this.state.country == "CZ" && <th><Translate id="Search.Cee.LastChange" /></th>}
                                                {this.state.country == "CZ" && <th><Translate id="Search.Cee.LastChangeDesc" /></th>}
                                                {this.state.country == "CZ" && <th><span title={this.props.translate('Search.Cee.ExecutionOrder.Description')}><Translate id="Search.Cee.ExecutionOrder" /></span></th>}
                                                <th style={{ textAlign: "right" }}>
                                                    <Translate id={this.state.country === "CZ" ? "Search.Cee.MonetaryObligationCZ" : "Search.Cee.MonetaryObligationEUR"} />
                                                </th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.data.details.map((d) => {
                                                return (<tr key={d.resultId}>
                                                    <td data-label={this.props.translate('Search.Cee.Type')}>
                                                        {d.subjectType === "1" && <Translate id="Search.Cee.Type.Company" />}
                                                        {d.subjectType === "2" && <Translate id="Search.Cee.Type.Person" />}
                                                        {d.subjectType === "3" && <Translate id="Search.Cee.Type.SoleTrader" />}
                                                    </td>
                                                    <td data-label={this.props.translate('Search.Relations.Subject')}>
                                                        <div><b>{d.name} </b></div>
                                                        <div>{d.address} </div>
                                                        {!isNullOrUndefined(d.birthDateFormated) && <div>{this.props.translate('Search.Common.BirthDate') + ' ' + d.birthDateFormated + ' '}</div>}
                                                        {!isNullOrUndefined(d.companyId) && !this.isEmpty(d.companyId) && <div>{this.props.translate('Report.PublicContracts.Ico') + ' ' + d.companyId + ' '}</div>}
                                                    </td>
                                                    <td data-label={this.props.translate('Search.Cee.Cause.FileNo')}>{d.exNumber}</td>
                                                    {this.state.country == "CZ" && <td data-label={this.props.translate('Search.Cee.ExecutionInitiation')}> {d.courtOrderDateFormatted}</td>}
                                                    {this.state.country == "CZ" && <td data-label={this.props.translate('Search.Cee.RegDate')}> {d.creationDateFormated}</td>}
                                                    {this.state.country == "CZ" && <td data-label={this.props.translate('Search.Cee.LastChange')}> {d.changeDateFormated}</td>}
                                                    {this.state.country == "CZ" && <td data-label={this.props.translate('Search.Cee.LastChangeDesc')}>{d.lastChange}</td>}
                                                    {this.state.country == "CZ" && <td data-label={this.props.translate('Search.Cee.ExecutionOrder')}>{d.executionOrder === true ? this.props.translate('Common.Yes.Lower') : d.executionOrder === false ? this.props.translate('Common.No.Lower') : ""}</td>}
                                                    <td data-label={this.props.translate(this.state.country === "CZ" ? "Search.Cee.MonetaryObligationCZ" : "Search.Cee.MonetaryObligationEUR")} style={{ textAlign: "right" }}>
                                                        <div>
                                                            <div style={{ display: "inline-flex", alignItems: "center" }}>
                                                                <span style={{ paddingRight: "0.4em" }}>{d.oneTimePrice ? <Money value={d.oneTimePrice} fractionDigits={2} /> : "-"}</span>
                                                                <div style={{ width: "1.6em", marginRight: "0.65em" }}>
                                                                    <div className="d-flex">
                                                                        <div className="d-inline-block" style={{ flexBasis: "50%", maxWidth: "1.6em" }}>
                                                                            <BbCheckbox onChange={() => this.onRequestIdChange(d.resultId)}
                                                                                value={this.state.option === OPTIONS.all || this.isChecked(d.resultId)} id={`chk-${d.resultId}`} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex">
                                                            <div className="d-inline-block text-center" style={{ flexBasis: "50%" }}>
                                                                {d.causeRequestId !== 0 &&
                                                                    <NavLink to={`/search/${this.state.fragment}/results/cause/${d.causeRequestId}`}>
                                                                        <span style={{ height: "2em", width: "2em", padding: "0", fontSize: "1.2em" }} className="link-functional">
                                                                            <Translate id="Report.Detail" />
                                                                        </span>
                                                                    </NavLink>
                                                                }
                                                                {d.causeRequestId === 0 && ((this.state.country === "CZ" && hasPermission(null, "CEEDetail")) || (this.state.country !== "CZ" && hasPermission(null, "CREReport"))) &&
                                                                    <span onClick={() => this.showPopup(false, d.causeId, d.exNumber)}
                                                                        style={{ height: "2em", width: "2em", padding: "0", fontSize: "1.2em" }} className="link-functional">
                                                                        <Translate id="Report.Detail" />
                                                                    </span>}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>)
                                            })}
                                        </tbody>
                                    </table>
                                </ResponsiveTable>
                            </div>
                            }
                            <ExcelExportButton ceeCre={this.props.match.params.id} country={this.state.country} />
                        </div>
                    </div>
                    <div className="disclaimer-wrapper">
                        <div className="disclaimer-gray">
                            <Translate id={this.state.country === "SK" ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} />
                        </div>
                    </div>
                </>}
            </div>
        )
    }

    isEmpty = (value) => {
        return value.trim().length == 0;
    }

    renderErrors = () => {
        if ((this.props[this.state.fragment].requestResult === false &&
            !isNullOrUndefined(this.props[this.state.fragment].responseData) && (
                !isNullOrUndefined(this.props[this.state.fragment].responseData.exception) ||
                !isNullOrUndefined(this.props[this.state.fragment].responseData.errorFile) ||
                !!this.props[this.state.fragment].responseData.error))
            || (!isNullOrUndefined(this.state.responseData) && (
                !isNullOrUndefined(this.state.responseData.exception) ||
                !isNullOrUndefined(this.state.responseData.errorFile) ||
                !!this.state.responseData.error))
            || (!isNullOrUndefined(this.state.errors) && !isNullOrUndefined(this.state.errors.exception))
        ) {
            return (
                <div style={{ marginTop: "1em" }}>
                    {((!isNullOrUndefined(this.props[this.state.fragment].responseData) && !isNullOrUndefined(this.props[this.state.fragment].responseData.exception)) ||
                        (!isNullOrUndefined(this.state.responseData) && !isNullOrUndefined(this.state.responseData.exception))
                    ) && <Message type="error" message="">
                            {!isNullOrUndefined(this.state.responseData) && !!this.state.responseData.exception
                                ? <Translate options={{ renderInnerHtml: true }} id={this.state.responseData.exception}
                                    data={isNullOrUndefined(this.state.responseData.exceptionData) ? undefined : this.state.responseData.exceptionData}
                                />
                                : <Translate options={{ renderInnerHtml: true }} id={this.props[this.state.fragment].responseData.exception}
                                    data={isNullOrUndefined(this.props[this.state.fragment].responseData.exceptionData)
                                        ? undefined : this.props[this.state.fragment].responseData.exceptionData}
                                />}
                        </Message>}
                    {((!isNullOrUndefined(this.props[this.state.fragment].responseData) && !!this.props[this.state.fragment].responseData.error) ||
                        (!isNullOrUndefined(this.state.responseData) && !!this.state.responseData.error)
                    ) && <Message type="error" message="">
                            {!isNullOrUndefined(this.state.responseData) && !!this.state.responseData.error
                                ? <Translate options={{ renderInnerHtml: true }} id={isNullOrUndefined(this.state.responseData.error.message)
                                    ? this.state.responseData.error : this.state.responseData.error.message} />
                                : <Translate options={{ renderInnerHtml: true }} id={isNullOrUndefined(this.props[this.state.fragment].responseData.error.message)
                                    ? this.props[this.state.fragment].responseData.error : this.props[this.state.fragment].responseData.error.message} />}
                        </Message>}
                    {(!isNullOrUndefined(this.state.errors) && !isNullOrUndefined(this.state.errors.exception)) &&
                        <Message type="error" message="">
                            {this.state.errors && this.state.errors.exception
                                && <Translate options={{ renderInnerHtml: true }} id={this.state.errors.exception}
                                    data={this.state.errors.exception}
                                />}
                        </Message>}
                </div>
            );
        }
    }

    setRpveData = (data, searchType, registry) => {
        this.setState({ fragment: registry, searchType: searchType, data: data }, () => this.updateData(data, true));
    }

    updateData = (data, fromRpve) => {
        this.setState({ responseData: undefined });
        const generatedDataForServer = this.generateDataForServer(data.header, fromRpve);
        generatedDataForServer.oldRequestDate = data.header.inserted;
        apiPost(
            `${window.babylonApiUrl}/api/search/${this.state.fragment}/check/${this.state.searchType}`,
            null,
            generatedDataForServer,
            (res) => {
                this.setState({ [`${this.state.fragment}Check`]: res.data });
                if (res.data.isSuccess) {
                    if (isNullOrUndefined(res.data.requestId))
                        this.confirmationPopup(this.state.data.header, fromRpve);
                    else {
                    const path = `/search/${this.state.fragment}/results/${res.data.requestId}`;
                        if (res.data.isCustomerRequest)
                    this.decisionPopup(this.state.data.header, generatedDataForServer, res.data.requestDateFormatted, path);
                        else
                            this.props.history.push(path);
                    }
                } else
                    this.onError(res.data);
            },
            (err) => this.onError(err.data)
        );
    }

    confirmationPopup = (headerValues, fromRpve) => {
        this.props.showPopup('ceeConfirmation', {
            title: this.props.translate('Search.Common.Warning'),
            open: true,
            style: { display: "block", flex: "initial" },
            close: () => { this.props.hidePopup(); },
            no: () => this.props.hidePopup(),
            yes: () => this.yesOnConfirmationAction(headerValues, fromRpve),
            formData: { // it is needed to take into account that all sections (fo, po, fpo) are under the single form - for example it is needed to prevent
                // from showing company name field from 'po' section in 'fo' section confirmation dialog
                birthId: this.state.searchType !== SEARCH_TYPE.fo || isNullOrUndefined(headerValues.pid) || headerValues.pid.trim() === '' ? undefined : headerValues.pid.trim(),
                fullName: this.state.searchType !== SEARCH_TYPE.fo || isNullOrUndefined(headerValues.fullName) || headerValues.fullName.trim() === '' ? undefined : headerValues.fullName.trim(),
                birthDate: this.state.searchType !== SEARCH_TYPE.fo || isNullOrUndefined(headerValues.birthDate) || headerValues.birthDate === '' ? undefined : headerValues.birthDate,
                ico: isNullOrUndefined(headerValues.companyId) || headerValues.companyId.trim() === '' ? undefined : headerValues.companyId.replace(/\s/g, ''),
                address: this.state.searchType !== SEARCH_TYPE.fo || isNullOrUndefined(headerValues.city) || headerValues.city.trim() === '' ? undefined : headerValues.city.trim(),
                companyName: this.state.searchType !== SEARCH_TYPE.po || isNullOrUndefined(headerValues.companyName) || headerValues.companyName.trim() === '' ? undefined : headerValues.companyName.trim(),
                firstName: this.state.searchType !== SEARCH_TYPE.fo || isNullOrUndefined(headerValues.firstName) || headerValues.firstName.trim() === '' ? undefined : headerValues.firstName.trim(),
                name: this.state.searchType !== SEARCH_TYPE.fo || isNullOrUndefined(headerValues.name) || headerValues.name.trim() === '' ? undefined : headerValues.name.trim(),
                surname: this.state.searchType !== SEARCH_TYPE.fo || isNullOrUndefined(headerValues.surname) || headerValues.surname.trim() === '' ? undefined : headerValues.surname.trim(),
                city: this.state.searchType !== SEARCH_TYPE.fo || isNullOrUndefined(headerValues.city) || headerValues.city.trim() === '' ? undefined : headerValues.city.trim(),
                trialFileNumber: this.state.searchType !== SEARCH_TYPE.trialFile || isNullOrUndefined(headerValues.courtFileNumber) || headerValues.courtFileNumber.trim() === '' ? undefined : headerValues.courtFileNumber.trim()
            },
            // includeMonetary: values.includeMonetary,
            // maxCauses: values.maxCauses === '' ? undefined : values.maxCauses,
            // monetaryData: values.includeMonetary === true ? {
            //     maxTotalCauses: values.maxTotalCauses === '' ? undefined : values.maxTotalCauses,
            //     minCauseDate: this.state.fragment !== REGISTRY.cee || values.minCauseDate === '' ? undefined : values.minCauseDate,
            //     minCauseAmount: values.minCauseAmount === '' ? undefined : values.minCauseAmount,
            //     year: this.state.fragment !== REGISTRY.cre || values.year === '' ? undefined : values.year
            // } : undefined,
            requestType: this.state.searchType,
            ceeCheck: this.state.ceeCheck,
            creCheck: this.state.creCheck,
            rpveCheck: this.state.rpveCheck,
            registry: this.state.fragment
        });
    }

    yesOnConfirmationAction = (headerValues, fromRpve) => {
        this.props.hidePopup();

        let searchData = this.generateDataForServer(headerValues, fromRpve);
        switch (this.state.searchType) {
            case SEARCH_TYPE.fo:
                this.props.initiateCeeRequestOnFo(this.state.fragment, this.state.fragment, searchData);
                break;
            case SEARCH_TYPE.po:
                this.props.initiateCeeRequestOnPo(this.state.fragment, this.state.fragment, searchData);
                break;
            case SEARCH_TYPE.trialFile:
                this.props.initiateCeeRequestOnTrialFile(this.state.fragment, this.state.fragment, searchData);
                break;
            default:
                break;
        }
        this.setState({ refreshReqInit: true });
    }

    generateDataForServer = (headerValues, fromRpve) => {
        let searchData = {}
        // searchData.monetaryInfo = this.state.searchType === SEARCH_TYPE.trialFile ? undefined : undefined; //this.getMonetaryInfoFromForm(formValues);

        switch (this.state.searchType) {
            case SEARCH_TYPE.fo:
                if (this.state.fragment === REGISTRY.cre) {
                    searchData.firstName = isNullOrUndefined(headerValues.name) || headerValues.name.trim() === '' ? null : headerValues.name.trim();
                    searchData.surname = isNullOrUndefined(headerValues.surname) || headerValues.surname.trim() === '' ? null : headerValues.surname.trim();
                    searchData.city = isNullOrUndefined(headerValues.city) || headerValues.city.trim() === '' ? null : headerValues.city.trim();
                }
                if (this.state.fragment === REGISTRY.cee) {
                    searchData.fullName = isNullOrUndefined(headerValues.fullName) || headerValues.fullName.trim() === '' ?
                        isNullOrUndefined(headerValues.surname) || headerValues.surname.trim() === '' ? null : headerValues.surname.trim()
                        : headerValues.fullName.trim();
                    searchData.ico = isNullOrUndefined(headerValues.companyId) || headerValues.companyId.trim() === '' ? null : headerValues.companyId.replace(/\s/g, '');
                    searchData.address = isNullOrUndefined(headerValues.city) || headerValues.city.trim() === '' ? null : headerValues.city.trim();
                }
                if (this.state.fragment === REGISTRY.rpve) {
                    searchData.firstName = isNullOrUndefined(headerValues.name) || headerValues.name.trim() === '' ? null : headerValues.name.trim();
                    searchData.surname = isNullOrUndefined(headerValues.surname) || headerValues.surname.trim() === '' ? null : headerValues.surname.trim();
                }
                searchData.birthId = isNullOrUndefined(headerValues.pid) || headerValues.pid.trim() === '' ? null : headerValues.pid.trim().replace('/', '');
                searchData.birthDate = isNullOrUndefined(headerValues.birthDate) || headerValues.birthDate === '' ? null : headerValues.birthDate;
                break;
            case SEARCH_TYPE.po:
                searchData.ico = isNullOrUndefined(headerValues.companyId) || headerValues.companyId.trim() === '' ? null : headerValues.companyId.replace(/\s/g, '');
                searchData.name = isNullOrUndefined(headerValues.companyName) || headerValues.companyName.trim() === '' ? null : headerValues.companyName.trim();
                break;
            case SEARCH_TYPE.trialFile:
                searchData.trialFileNumber = isNullOrUndefined(headerValues.courtFileNumber) || headerValues.courtFileNumber.trim() === '' ? null : headerValues.courtFileNumber.trim()
                break;
            default:
                break;
        }
        if (this.state.fragment === REGISTRY.cre)
            searchData.fromRpve = fromRpve;

        return searchData;
    }

    decisionPopup = (values, generatedDataForServer, requestDate, continuePath) => {
        this.props.showPopup('ceeDecision', {
            title: this.props.translate('Common.Information'),
            open: true,
            close: () => { this.props.hidePopup(); },
            requestDate: requestDate,
            continue: () => {
                //re-use the old request  
                if (!isNullOrUndefined(continuePath) && continuePath !== '')
                    this.props.history.push(continuePath);
                else
                    this.props.hidePopup();
            },
            newRequest: () => {
                this.props.hidePopup();
                generatedDataForServer.forceNewRequest = true;
                //check credit to get accurate price and create a new request
                apiPost(
                    `${window.babylonApiUrl}/api/search/${this.state.fragment}/check/${this.state.searchType}`,
                    null,
                    generatedDataForServer,
                    (res) => {
                        this.setState({ [`${this.state.fragment}Check`]: res.data });
                        if (res.data.isSuccess) {
                            if (isNullOrUndefined(res.data.requestId))
                                this.confirmationPopup(values, generatedDataForServer.fromRpve);
                            else
                                this.props.history.push(continuePath);
                        } else
                            this.onError(res.data);
                    },
                    (err) => this.onError(err.data)
                );
            }
        });
    }

    showPopup = (massRequest, causeId, exNumber) => {
        let option = this.getOptionLabel(this.state.option, true);
        let count = !massRequest ? 1 : this.state.checked.length;
        let causeIds = !massRequest ? [causeId] : this.getCauseIdsFromChecked();
        this.props.showPopup('ceeDetailConfirmation', {
            title: massRequest ? this.props.translate('Search.Cee.Cause.Warning.Obligation') : this.props.translate('Search.Cee.Cause.Warning'),
            open: true,
            close: () => { this.props.hidePopup(); },
            no: () => this.props.hidePopup(),
            yes: () => massRequest ? this.submitMultiple(this.props.match.params.id, causeIds) : this.submitSingle(this.props.match.params.id, causeIds[0]),
            data: {
                id: this.props.match.params.id,
                country: this.state.country,
                option: option,
                count: count,
                causeIds: causeIds,
                massRequest: massRequest,
                exNumber: exNumber
            }
        });
    }

    getCauseIdsFromChecked = () => {
        let result = [];
        this.state.checked.map(ch => {
            result.push(this.state.data.details.find(x => x.resultId === ch).causeId);
        })
        return result;
    }

    getOptionLabel = (option, forModal = false) => {
        switch (option) {
            case OPTIONS.all: return "Search.Cee.AllCases";
            case OPTIONS.firstN: return forModal ? "Search.Cee.First.N.Var" : "Search.Cee.First.N";
            case OPTIONS.choose: return "Search.Cee.Choose";
            default: return "Search.Cee.Choose"
        }
    }

    getObligationCount = (count) => {
        switch (this.state.option) {
            case OPTIONS.all: return -1;
            case OPTIONS.firstN: return count;
            case OPTIONS.choose: return 0;
            default: return 0;
        }
    }

    submitSingle = (id, causeId) => {
        let url = `${this.getBaseUrl(id)}/cause/${causeId}/detail`;
        let params = { isObligationRequest: true, country: this.state.country, obligationCount: 0 };
        apiPost(url, params, null, (response) => this.getCauseDetailCallback(response))
    }

    getCauseDetailCallback = (response) => {
        this.props.hidePopup();
        if (response && response.code === 404)
            writeErr("Something went wrong");
        else
            if (response.data && response.data.exception)
                this.setState({ errors: response.data });
            else
                this.props.history.push(`/search/${this.state.fragment}/results`)
    }

    submitMultiple = (id, causeIds) => {
        let url = `${this.getBaseUrl(id)}/cause/detail`;
        let oblCount = this.getObligationCount(causeIds.length);
        let params = { isObligationRequest: true, obligationCount: oblCount, country: this.state.country, };
        apiPost(url, params, causeIds, (response) => this.getCauseDetailCallback(response))
    }

    onOptionChange = (option) => {
        if (option === OPTIONS.all) {
            let ids = this.state.data.details.map(x => x.resultId);
            this.setState({ checked: ids, option: option });
        }
        if (option === OPTIONS.firstN)
            this.onHowManyChange(this.state.howMany);
        if (option === OPTIONS.choose)
            this.setState({ option: option, checked: [] });
    }

    onHowManyChange = (howMany) => {
        let parsed = parseInt(howMany, 10);
        if (isNullOrUndefined(parsed) || isNaN(parsed)) {
            this.setState({ howMany: undefined, checked: [], option: OPTIONS.firstN })
            return;
        }
        if (parsed < CAUSES_MIN)
            parsed = 1;
        const len = this.state.data.details.map(x => x.resultId).length;
        const max = len > CAUSES_MAX ? CAUSES_MAX : len;
        if (parsed > max)
            parsed = max;
        let ids = this.state.data.details.map(x => x.resultId).slice(0, parsed);
        this.setState({ howMany: parsed, checked: ids, option: OPTIONS.firstN })
    }

    onRequestIdChange = (id) => {
        //remove item from list
        if (this.state.checked.indexOf(id) >= 0)
            this.setState({ checked: this.state.checked.filter(x => x !== id), option: OPTIONS.choose });
        else {
            let temp = this.state.checked;
            temp.push(id);
            //if all are checked change option
            if (temp.length === this.state.data.details.length)
                this.setState({ option: OPTIONS.all });
            else
                this.setState({ option: OPTIONS.choose });
            this.setState({ checked: temp }) //push to checked ids
        }
    }

    getData = () => {
        this.setState({ isLoading: true });
        this.props.setResultsRequestParams(this.state.fragment, null);


        apiGet(this.getBaseUrl(this.props.match.params.id),
            { country: this.state.country, isRpve: this.state.isRpve },
            (data) => {
                if (isNullOrUndefined(data.error) && !isNullOrUndefined(data.data))
                    this.onGetDataSuccess(data.data);
                else {
                    this.setState({ errors: { exception: data.error.message } });
                    this.onError();
                }
            },
            () => this.onError()
        );
    }

    onGetDataSuccess = (data) => {
        let option = 0;
        if (data.header.obligation === -1) { option = OPTIONS.all }
        if (data.header.obligation === 0) { option = OPTIONS.choose }
        if (data.header.obligation > 0 || data.header.obligation === null) { option = OPTIONS.firstN }

        if (!data.isCustomerResult) {
            apiPost(this.getBaseUrl(this.props.match.params.id) + '/mark-as-seen', { country: this.state.country }, null,
                () => this.onSuccess(data, option),
                () => this.onError()
            );
        } else {
            this.onSuccess(data, option)
        }
    }

    onSuccess = (data, option) => {
        const toCheck = data.header.maxDetails > CAUSES_MAX ? CAUSES_MAX : data.header.maxDetails;
        const checked = isNullOrUndefined(toCheck) || toCheck === 0 ? [] : data.details.slice(0, toCheck).map(x => x.resultId);
        let searchType = null;
        switch (data.header.type) {
            case "Person": searchType = SEARCH_TYPE.fo; break;
            case "Company": searchType = SEARCH_TYPE.po; break;
            case "Cause": searchType = SEARCH_TYPE.trialFile; break;
            default: searchType = null; break;
        }
        this.setState({ isLoading: false, data: data, searchType: searchType, howMany: toCheck, option: option, checked: checked });
        this.props.setResultsRequestParams(this.state.fragment, { subPath: 'requests', id: parseInt(this.props.match.params.id), params: { country: this.state.country } });
    }

    onError = (data) => this.setState({ isLoading: false, responseData: data });
    isChecked = (id) => this.state.checked.indexOf(id) >= 0;
    getBaseUrl = (id) => `${window.babylonApiUrl}/api/search/cee/requests/${id}`;
    hasOneTimePrice = () => this.state.data.details.filter(x => x.oneTimePrice).length > 0;
}


export default withLocalize(connect(
    state => state.registrySearch,
    dispatch => bindActionCreators({ ...registrySearchActions, ...popupActions }, dispatch)
)(CeeDetail));